<div class="space-y-6">
  <!-- personal details -->
  <app-profile-tab-card title="Personal details" [icon]="faIdCard" iconColorClass="text-mty-primary">
    <div class="space-y-4">
      <div>
        <label class="block mb-1 text-sm font-medium text-mty-body">
          {{ 'First name' | translate }}
        </label>
        <input type="text" class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-mty-primary focus:outline-none focus:ring-1 focus:ring-mty-primary" [ngModel]="editableEntity().firstName" (ngModelChange)="updateEntityField('firstName', $event)" />
      </div>
      <div>
        <label class="block mb-1 text-sm font-medium text-mty-body">
          {{ 'Last name' | translate }}
        </label>
        <input type="text" class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-mty-primary focus:outline-none focus:ring-1 focus:ring-mty-primary" [ngModel]="editableEntity().lastName" (ngModelChange)="updateEntityField('lastName', $event)" />
      </div>
      <div>
        <label class="block mb-1 text-sm font-medium text-mty-body">
          {{ 'Birthdate' | translate }}
        </label>
        <app-input-birthdate [ngModel]="editableEntity().birthDate" (ngModelChange)="updateEntityField('birthDate', $event)"></app-input-birthdate>
      </div>
      <div class="flex justify-end">
        <button type="button" class="inline-flex items-center gap-1.5 rounded-full bg-mty-primary px-4 py-2 text-sm font-medium text-white hover:bg-mty-primary/90 transition-colors" (click)="updateStudentprofile()">
          <fa-icon [icon]="faSave" class="text-[10px]"></fa-icon>
          <span>{{ 'Save' | translate }}</span>
        </button>
      </div>
    </div>
  </app-profile-tab-card>

  <!-- interests -->
  <app-profile-tab-card title="Professional interests" [icon]="faStar" iconColorClass="text-amber-500" [count]="entity().areaOfInterests?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="editInterests()">
      <fa-icon [icon]="faEdit" class="text-[10px] mr-1.5"></fa-icon>
      <span>{{ 'Edit' | translate }}</span>
    </button>
    <a id="sectionareaofinterests"></a>
    @if (!entity().areaOfInterests || entity().areaOfInterests?.length === 0) {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    } @else {
    <div class="flex flex-wrap gap-2">
      @for (interest of entity().areaOfInterests ?? []; track interest.id) {
      <span class="inline-flex items-center rounded-full bg-mty-primary/10 px-3 py-1 text-xs font-medium text-mty-primary">
        {{ interestService.getTranslatedName(interest) }}
      </span>
      }
    </div>
    }
  </app-profile-tab-card>

  <!-- work experience -->
  <app-profile-tab-card title="Work experiences" [icon]="faBriefcase" iconColorClass="text-mty-primary" [count]="entity().workExperiences?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addWorkexperience()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectionworkexperiences"></a>
    @if (entity().workExperiences && entity().workExperiences!.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Company' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Job title' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().workExperiences; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3">{{ row.companyName }}</td>
            <td class="py-2 pr-3">{{ row.jobTitle }}</td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <button type="button" class="inline-flex items-center mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="updateWorkexperience(row)">
                <fa-icon [icon]="faEdit" class="text-[10px]"></fa-icon>
              </button>
              <button type="button" class="inline-flex items-center text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteWorkexperience(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>

  <!-- educations -->
  <app-profile-tab-card title="Educations" [icon]="faGraduationCap" iconColorClass="text-emerald-600" [count]="entity().educations?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addEducation()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectioneducations"></a>
    @if (entity().educations && entity().educations!.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Title' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'School' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Start date' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'End date' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().educations; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3">{{ row.programName }}</td>
            <td class="py-2 pr-3">{{ row.schoolName }}</td>
            <td class="py-2 pr-3 whitespace-nowrap">
              {{ row.startDate ? (row.startDate | date: 'dd-MM-YYYY') : '' }}
            </td>
            <td class="py-2 pr-3 whitespace-nowrap">
              {{ row.endDate ? (row.endDate | date: 'dd-MM-YYYY') : '' }}
            </td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <button type="button" class="inline-flex items-center mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="updateEducation(row)">
                <fa-icon [icon]="faEdit" class="text-[10px]"></fa-icon>
              </button>
              <button type="button" class="inline-flex items-center text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteEducation(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>

  <!-- languages -->
  <app-profile-tab-card title="Languages" [icon]="faLanguage" iconColorClass="text-sky-600" [count]="entity().languageProficiencies?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addLanguage()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectionlanguages"></a>
    @if (
    entity().languageProficiencies && entity().languageProficiencies!.length > 0
    ) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Language' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Speech' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Reading' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Writing' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().languageProficiencies; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3">{{ locale.getLanguageName(row.languageCode ?? '') }}</td>
            <td class="py-2 pr-3">
              {{ LanguageProficiencyUtils.getLevelName(row.speakingProficiency ?? 0) | translate }}
            </td>
            <td class="py-2 pr-3">
              {{ LanguageProficiencyUtils.getLevelName(row.readingProficiency ?? 0) | translate }}
            </td>
            <td class="py-2 pr-3">
              {{ LanguageProficiencyUtils.getLevelName(row.writingProficiency ?? 0) | translate }}
            </td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <button type="button" class="inline-flex items-center mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="updateLanguage(row)">
                <fa-icon [icon]="faEdit" class="text-[10px]"></fa-icon>
              </button>
              <button type="button" class="inline-flex items-center text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteLanguage(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>

  <!-- foreign experience -->
  <app-profile-tab-card title="Foreign experiences" [icon]="faPlane" iconColorClass="text-indigo-600" [count]="entity().foreignExperiences?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addForeignexperience()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectionforeignexperiences"></a>
    @if (entity().foreignExperiences && entity().foreignExperiences!.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Experience' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'From' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'Till' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().foreignExperiences; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3">{{ row.title }}</td>
            <td class="py-2 pr-3 whitespace-nowrap">
              {{ row.startDate ? (row.startDate | date: 'dd-MM-YYYY') : '' }}
            </td>
            <td class="py-2 pr-3 whitespace-nowrap">
              {{ row.endDate ? (row.endDate | date: 'dd-MM-YYYY') : '' }}
            </td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <button type="button" class="inline-flex items-center mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="updateForeignexperience(row)">
                <fa-icon [icon]="faEdit" class="text-[10px]"></fa-icon>
              </button>
              <button type="button" class="inline-flex items-center text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteForeignexperience(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>

  <!-- hobby -->
  <app-profile-tab-card title="Hobbies" [icon]="faSmile" iconColorClass="text-rose-500" [count]="entity().interests?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addInterest()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectioninterests"></a>
    @if (entity().interests && entity().interests!.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Hobby / interest' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().interests; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3">{{ row.description }}</td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <button type="button" class="inline-flex items-center mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="updateInterest(row)">
                <fa-icon [icon]="faEdit" class="text-[10px]"></fa-icon>
              </button>
              <button type="button" class="inline-flex items-center text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteInterest(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>

  <!-- resume -->
  <app-profile-tab-card title="Resume" [icon]="faFileLines" iconColorClass="text-mty-primary" [count]="entity().studentProfileCvs?.length ?? 0">
    <button tabAction type="button" class="inline-flex items-center text-sm font-medium text-mty-primary hover:text-mty-body transition-colors" (click)="addResume()">
      {{ 'Add' | translate }}
    </button>
    <a id="sectionresume"></a>
    @if (entity().studentProfileCvs && entity().studentProfileCvs!.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left text-mty-body">
        <thead class="text-xs uppercase tracking-wide text-mty-body/60">
          <tr>
            <th class="py-2 pr-3 font-medium">{{ 'Date' | translate }}</th>
            <th class="py-2 pr-3 font-medium">{{ 'File' | translate }}</th>
            <th class="py-2 pr-3 sr-only">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entity().studentProfileCvs; track row.id) {
          <tr class="border-t border-gray-100 odd:bg-gray-50/60">
            <td class="py-2 pr-3 whitespace-nowrap">
              {{ row.createdOn | date: 'dd-MM-YYYY' }}
            </td>
            <td class="py-2 pr-3">{{ row.filename }}</td>
            <td class="py-2 pr-3 text-right whitespace-nowrap">
              <a [href]="row.uri" target="_blank" class="inline-flex items-center gap-1.5 mr-3 text-sm font-medium text-mty-primary hover:text-mty-body transition-colors">
                <fa-icon [icon]="faDownload" class="text-[10px]"></fa-icon>
                <span>{{ 'Download' | translate }}</span>
              </a>
              <button type="button" class="inline-flex items-center gap-1.5 text-sm font-medium text-mty-danger hover:text-mty-body transition-colors disabled:opacity-40 disabled:cursor-not-allowed" (click)="deleteResume(row.id!)" [disabled]="!row.id">
                <fa-icon [icon]="faTimes" class="text-[10px]"></fa-icon>
                <span>{{ 'Delete' | translate }}</span>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    } @else {
    <div class="text-center py-6 text-sm text-mty-body/60">
      {{ 'No results' | translate }}
    </div>
    }
  </app-profile-tab-card>
</div>
